import { LoaderServiceService } from './../../providers/loader-service.service';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'src/app/providers/shared.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { AddNewEmployeeComponent } from 'src/app/shared/components/add-new-employee/add-new-employee.component';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';

@Component({
  selector: 'sm-employee-invitation',
  templateUrl: './employee-invitation.component.html',
  styleUrls: ['./employee-invitation.component.scss']
})
export class EmployeeInvitationComponent implements OnInit,OnDestroy {


  messageList: any[] = [];
  employeeData: any = []
  entityHashId: string =''
  public loader: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "date of joining",
      columnProperty: "dateOfJoin"
    },
    {
      columnName: "phone",
      columnProperty: "phone"
    },
   
    {
      columnName: "total sales",
      columnProperty: "totalSales"
    },
  ];
  private _apiSubscription: Subscription;
  clickEventSubscription: Subscription;
  constructor(private sharedService: SharedService, private _apiService: ApiService,private _dialog: MatDialog, private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private loaderservice: LoaderServiceService,private angularFireMessaging: AngularFireMessaging
    ) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_REQUEST_LIST){
        console.log(resData);
        this.employeeData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.employeeData.push(element)
          });
        }
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_SEND_EMPLOYEE_REQUEST){ 
        if(resData.result){
          this.ngOnInit()
          
          // window.location.reload()
          // this.router.navigate(["/businesses", "details", "employees", "employee-invitation"], {
          //   queryParamsHandling: 'preserve'
          // });
        }
       }
      console.log(this.employeeData);
      
      this.loader = false;
      this.loaderservice.showLoader = false
    });
    // this.loader = false;
  }

  ngOnInit(): void {
    this.loader =true
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.loaderservice.showLoader = true
    this._apiService.getEmployeeRequestList(this.entityHashId);
    
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  viewDetails(requestHashId:any){
    this.router.navigate(["/businesses", "details", "employees", "employee-invitation", "invitation-details"], {
      queryParams: {'requestHashId': requestHashId},
      queryParamsHandling: 'merge'
    });
  }

  addNewEmployee(){
    this._dialog.open(AddNewEmployeeComponent, {
      width: '500px',
      data: {
        title: 'Add New Employee',
        ref: this._dialog
      },
    });
  }

}
